import { ChangeDetectionStrategy, Component } from '@angular/core';
import { VQcards } from './vq-cards';
import { VqIntroComponent } from './vq-intro/vq-intro.component';
import { VgSolveProblemsComponent } from './vq-solve-problems/vq-solve-problems.component';
import { VqAdvantagesComponent } from './vq-advantages/vq-advantages.component';
import { PygXCardComponent } from '@pyg-shared/pyg-x-card/pyg-x-card.component';
import { VqBenefitsComponent } from './vq-benefits/vq-benefits.component';

@Component({
  selector: 'app-virtual-queue',
  templateUrl: './virtual-queue.component.html',
  styleUrls: ['./virtual-queue.component.scss'],
  imports: [
    VqIntroComponent,
    VgSolveProblemsComponent,
    VqAdvantagesComponent,
    PygXCardComponent,
    VqBenefitsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualQueueComponent {
  public readonly VQcards = VQcards;
}
